var ww = window.innerWidth,
    wh = window.innerHeight,
    currentST = 0,
    targetST = 0,
    up = false,
    mainContent = document.getElementById("mainContent");

let _events = {},
    _scrollEvents = [],
    _startEvents = [];


// Helper Functions
const addScroll = (func) => {
    _scrollEvents.push({ func: func });
};
const removeAllScrollEvents = () => {
    _scrollEvents = [];
};
function scrollWatch(event) {
  const newST = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  wst = parseFloat(newST.toFixed(2));
  up = wst < currentST;
  currentST = wst;
  _scrollEvents.forEach(e => e.func());
}
// Loading
function addParam(url, param) {
  url += (url.split("?")[1] ? "&" : "?") + param;
  return url;
}
function noParam(url, param) {
  return url.split("?")[0];
}
function serialize(form) {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
          return;
      if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
              if (!option.selected) return;
              arr.push(
                  encodeURIComponent(field.name) +
                  "=" +
                  encodeURIComponent(option.value)
              );
          });
          return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
      arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
  });
  return arr.join("&");
}  
function handleHistory(formData, form){
  if(formData !== 'busca=') {
      window.history.pushState("", "", addParam(noParam(form.action), formData));
  }
  else{
      window.history.pushState("", "", noParam(form.action));
  }
}
function convertDate(dateString) {
  const months = {
    Jan: 0, Fev: 1, Mar: 2, Abr: 3, Mai: 4, Jun: 5,
    Jul: 6, Ago: 7, Set: 8, Out: 9, Nov: 10, Dez: 11
  };

  const dateParts = String(dateString).split('/');
  const month = months[dateParts[0]];
  const year = parseInt(dateParts[1]);

  return new Date(year, month);
}
function fontSize(aumentar, normal){
  const element = document.documentElement;
  let currentSize = parseFloat(window.getComputedStyle(element, null).getPropertyValue('font-size'));
  if (normal) {
      element.style.fontSize = '';
  } else {
      let fS = aumentar ? currentSize+2 : element.style.fontSize = '';
      element.style.fontSize = fS.toString() + 'px'; 
      localStorage.setItem("fontsize",fS.toString());
  }
}
function submitForm(event) {
    event.preventDefault(); 

    var form = document.getElementById('newsletter');
    var messageElement = document.getElementById('mensagem');
    var formData = new FormData(form);

    form.classList.add('loading');
    formData.append('ajaxform', 1);

    fetch(form.action || window.location.href, {
        method: 'POST',
        body: formData
    })
    .then(function(response) {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error('Erro HTTP: ' + response.status);
        }
    })
    .then(function(data) {
        messageElement.innerHTML = `<p class="resposta ${data.status ? 'success' : 'error'}">${data.resposta}</p>`;
        form.classList.remove('loading');
    })
    .catch(function(error) {
        console.error(error);
        messageElement.innerHTML = `<p class="resposta error">Ocorreu um erro. Tente novamente.</p>`;
        form.classList.remove('loading');
    });

    return false;
}
function updateResultsCount(html) {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  const meta = wrapper.querySelector(".ajax-meta");
  let total = null;

  if (meta) {
    total = parseInt(meta.dataset.total || "0", 10);
    meta.remove();
  }

  const resultsEl = document.querySelector(".results-count");
  if (resultsEl && total !== null) {
    if (total > 0) {
      const params = new URLSearchParams(window.location.search);
      const busca = params.get("busca") || "";

      const researcherWord =
        total === 1
          ? (window.GBB_I18N?.researcherSingular ?? "pesquisador")
          : (window.GBB_I18N?.researcherPlural ?? "pesquisadores");

      const tpl = busca
        ? (window.GBB_I18N?.showingFor ?? "Exibindo %d %s para “%s”")
        : (window.GBB_I18N?.showing ?? "Exibindo %d %s");

      let text = tpl;
      text = text.replace("%d", total);
      text = text.replace("%s", researcherWord);

      if (busca) {
        text = text.replace("%s", busca);
      }

      resultsEl.style.display = "";
      resultsEl.textContent = text;
    } else {
      // nenhum resultado ⇒ esconde
      resultsEl.style.display = "none";
    }
  }

  return wrapper.innerHTML;
}
function updateSelectedTags() {
  const container = document.querySelector('.active-filters');
  const form = document.querySelector('.filtro');
  if (!container || !form) return;

  container.innerHTML = '';

  const taxonomies = ['especie', 'localidade', 'escopo'];
  const tagClasses = {
    especie: 'tag-primary',
    localidade: 'tag-yellow',
    escopo: 'tag-secondary',
  };

  let hasFilter = false;

  taxonomies.forEach(tax => {
    const inputs = form.querySelectorAll(`input[name="${tax}[]"]:checked`);

    inputs.forEach(input => {
      hasFilter = true;

      const id = input.id;
      const labelEl = form.querySelector(`label[for="${id}"]`);
      const text = labelEl ? labelEl.textContent.trim() : input.value;

      // classe de cor baseada na taxonomia
      const variant = tagClasses[tax] || 'tag-primary';

      const tag = document.createElement('button');
      tag.type = 'button';
      tag.className = `tag-gbb ${variant} active-filter-tag`;
      tag.innerHTML = `
        <span>${text}</span>
      `;

      // Remover termo ao clicar
      tag.addEventListener('click', () => {
        input.checked = false;
        changeContent(form, new Event('submit'));
      });

      container.appendChild(tag);
    });
  });

  // limpar filtro
  if (hasFilter) {
    const clearBtnText = window.GBB_I18N?.clearFilters ?? "Limpar filtros";

    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'tag-gbb tag-text active-filter-clear';
    clearBtn.innerHTML = `
      <span>${clearBtnText}</span>
    `;

    clearBtn.addEventListener('click', () => {
      taxonomies.forEach(tax => {
        form.querySelectorAll(`input[name="${tax}[]"]`).forEach(inp => {
          inp.checked = false;
        });
      });

      const buscaInput = form.querySelector('input[name="busca"]');
      if (buscaInput) buscaInput.value = '';

      changeContent(form, new Event('submit'));
    });

    container.appendChild(clearBtn);
  }

  container.style.display = hasFilter ? 'flex' : 'none';
}
function loadContent(t) {
  t.classList.add("loading");

  const parent = t.closest(".loadParent");
  const container = parent.querySelector(".loadContainer");
  const form = parent.querySelector(".filtro");
  if (!container || !form) return false;

  const offset = container.querySelectorAll(".project-card").length;

  const http = new XMLHttpRequest();
  const formData = serialize(form);
  handleHistory(formData, form);

  http.open(
    "GET",
    addParam(noParam(form.action), formData + "&contentajax=true&offset=" + offset),
    true
  );

  http.onreadystatechange = function () {
    if (http.readyState === 4 && http.status === 200) {
      if (http.responseText && http.responseText.indexOf("<html") === -1) {
        const cleanedHTML = updateResultsCount(http.responseText);
        updateSelectedTags();
        container.insertAdjacentHTML("beforeend", cleanedHTML);
      }

      const btn = t.closest(".load-more-btn");
      if (btn) btn.remove();
    }
  };

  http.send();
}
function loadSearch(t) {

  const form  = document.querySelector('.filtro');
  const input = form ? form.querySelector('input[name="busca"]') : null;

  if (input && !input.dataset.listenerBound) {

    let previous = input.value;

    input.addEventListener('input', () => {
      const now = input.value.trim();

      if (previous && now === '') {
        changeContent(form, new Event('submit'));
      }

      previous = now;
    });

    input.dataset.listenerBound = "true";
  }

  t.classList.add("loading");

  const targetST =
    window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

  const parent = t.closest(".loadSearchParent");
  const container = parent && parent.querySelector(".loadSearchContainer");
  if (!container) return false;

  const current = new URL(window.location.href);
  const s = current.searchParams.get("s") || "";
  const qsBase = s ? "s=" + encodeURIComponent(s) : "";

  const offset = container.children.length - 1;

  const base = noParam(current.href);
  const qsFull = qsBase + (qsBase ? "&" : "") + "contentajax=true&offset=" + offset;
  const reqUrl = addParam(base, qsFull);

  if (qsBase && qsBase !== "s=") {
    window.history.pushState("", "", addParam(base, qsBase));
  } else {
    window.history.pushState("", "", base);
  }

  const http = new XMLHttpRequest();
  http.open("GET", reqUrl, true);

  http.onreadystatechange = function () {
    if (http.readyState === 4) {
      if (http.status === 200) {
        if (http.responseText && http.responseText.indexOf("<html") === -1) {
          const cleanedHTML = updateResultsCount(http.responseText);
          container.insertAdjacentHTML("beforeend", cleanedHTML);
          updateSelectedTags();
        }
      }
      window.scrollTo(0, targetST);
      t.remove();
    }
  };

  http.send();
}
function clearSearch() {
  const form  = document.querySelector('.filtro');
  const input = form ? form.querySelector('input[name="busca"]') : null;

  if (!form || !input) return;

  if (input.dataset.listenerBound === "true") return;

  let previous = input.value;

  input.addEventListener('input', () => {
    const now = input.value.trim();

    if (previous && now === '') {
      changeContent(form, new Event('submit'));
    }

    previous = now;
  });

  input.dataset.listenerBound = "true";
}

function changeContent(t, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const parent = t.closest(".loadParent");
  const container = parent.querySelector(".loadContainer");
  const form = parent.querySelector(".filtro");
  if (!container || !form) return false;

  container.classList.add("loading");
  form.classList.add("loading");

  const http = new XMLHttpRequest();
  const formData = serialize(form);
  handleHistory(formData, form);

  http.open("GET", addParam(noParam(form.action), formData + "&contentajax=true&offset=0"), true);

  http.onreadystatechange = function () {
    if (http.readyState === 4 && http.status === 200) {
      if (http.responseText && http.responseText.indexOf("<html") === -1) {
        const cleanedHTML = updateResultsCount(http.responseText);
        updateSelectedTags();
        container.innerHTML = cleanedHTML;
      } else {
        const noResultsText =
          window.GBB_I18N?.noResultsCombo ?? "Não há resultados para a combinação de filtros.";

        container.innerHTML = `<div class="post-results"><p>${noResultsText}</p></div>`;

        const resultsEl = document.querySelector(".results-count");
        if (resultsEl) resultsEl.style.display = "none";
      }
    }

    container.classList.remove("loading");
    form.classList.remove("loading");
  };

  http.send();
}
  
// General
const generalApp = {
  init: ()=>{

    //header e menu 

    const header = document.querySelector('header');
    const home   = document.querySelector('[data-page="home"]');
    const isHome = !!home;
    const menuHome = home?.querySelector('.header_bar');

    if (isHome && menuHome && window.innerWidth > 1023) {
      menuHome.classList.remove('header_nav');
    }

    // scroll events
    removeAllScrollEvents();
    addScroll(() => {
      if (window.innerWidth > 1023) {
        header.classList.toggle("translate-up", wst > 0);
        header.classList.toggle("translate-reset", up);

        if (isHome && menuHome) {
          menuHome.classList.toggle("header_nav", wst > 200);
        }
      }
      scrollPos = wst;
    });

    // Controle do menu mobile
    const mobileMenu = document.getElementById('mobile-menu');
    const line1 = document.getElementById('hamburger-line-1');
    const line2 = document.getElementById('hamburger-line-2');
    const line3 = document.getElementById('hamburger-line-3');

    let isMenuOpen = false;

    // Função para alternar menu mobile (global)
    toggleMobileMenu = function () {
      isMenuOpen = !isMenuOpen;

      if (isMenuOpen) {
        // Abre menu com fade
        mobileMenu.classList.remove('hidden');
        mobileMenu.classList.add('flex', 'mobile-menu-fade-in');
        mobileMenu.classList.remove('mobile-menu-fade-out');

        // Anima hambúrguer para X
        line1.classList.add('hamburger-x');
        line2.classList.add('hamburger-x-middle');
        line3.classList.add('hamburger-x-bottom');

        // Bloqueia scroll do body
        document.body.style.overflow = 'hidden';
      } else {
        // Fecha menu com fade
        mobileMenu.classList.add('mobile-menu-fade-out');
        mobileMenu.classList.remove('mobile-menu-fade-in');

        // Anima X para hambúrguer
        line1.classList.remove('hamburger-x');
        line2.classList.remove('hamburger-x-middle');
        line3.classList.remove('hamburger-x-bottom');

        // Libera scroll do body
        document.body.style.overflow = 'auto';

        // Esconde menu após animação
        setTimeout(() => {
          mobileMenu.classList.remove('flex');
          mobileMenu.classList.add('hidden');
          mobileMenu.classList.remove('mobile-menu-fade-out');
        }, 200);
      }
    };

    // Fecha menu ao clicar em um link
    mobileMenu.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') {
        isMenuOpen = false;
        toggleMobileMenu();
      }
    });

    // Select
    document.querySelectorAll('.select-lang').forEach(selectLang => {
      const labelLang = selectLang.querySelector('.label-lang');
      const hiddenValue = selectLang.querySelector('.lang-value');
      const checkDrop = selectLang.querySelector('.check-drop');

      const activeLink = selectLang.querySelector('.drop-options a.active');
      if (activeLink) {
        labelLang.textContent = activeLink.textContent.trim();
        hiddenValue.value = activeLink.textContent.trim();
      }

      selectLang.querySelectorAll('.lang-option').forEach(option => {
        option.addEventListener('click', () => {
          const value = option.getAttribute('data-value');
          labelLang.textContent = value;   
          hiddenValue.value = value;
          checkDrop.checked = false;
        });
      });

      document.addEventListener('click', (e) => {
        if (!selectLang.contains(e.target)) checkDrop.checked = false;
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') checkDrop.checked = false;
      });
    });


  }
};

// Parallax
const parallaxApp = {
  init() {
    const containers = document.querySelectorAll(
      '#grafismo-hero, #grafismo-intro, #grafismo-objetivos, #grafismo-genometro, #grafismo-faca-parte, #grafismo-timeline, #grafismo-hero-como-participar, #grafismo-hero-equipe-gestora, #grafismo-hero-documentos'
    );

    if (!containers.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.applyParallaxTo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    containers.forEach((container) => observer.observe(container));
  },

  applyParallaxTo(container) {
    const elements = container.querySelectorAll('svg');
    if (!elements.length) return;

    const parent =
      container.closest('section') ||
      container.closest('.section') ||
      container.closest('[id$="-section"]') ||
      container.parentElement;
    if (!parent) return;

    const intensity = 0.08;
    const maxMove = 50;

    let rect = parent.getBoundingClientRect();
    let sectionTop = rect.top + window.scrollY;
    let sectionHeight = parent.offsetHeight;

    window.addEventListener('resize', () => {
      rect = parent.getBoundingClientRect();
      sectionTop = rect.top + window.scrollY;
      sectionHeight = parent.offsetHeight;
    });

    const applyCombinedParallax = (x, y) => {
      const total = elements.length;

      elements.forEach((el, i) => {
        const depth = 0.4 + (i / (total - 1)) * 0.6;

        const finalX = Math.max(-maxMove, Math.min(maxMove, x * depth));
        const finalY = Math.max(-maxMove, Math.min(maxMove, y * depth));

        el.style.transition =
          'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        el.style.transform = `translate(${finalX}px, ${finalY}px)`;
      });
    };

    const resetParallax = () => {
      elements.forEach((el) => {
        el.style.transition =
          'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        el.style.transform = 'translate(0px, 0px)';
      });
    };

    let tickingMouse = false;
    let tickingScroll = false;

    const applyMouseParallax = (e) => {
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const deltaX = (e.clientX - centerX) * intensity;
      const deltaY = (e.clientY - centerY) * intensity;

      const moveX = Math.max(-maxMove, Math.min(maxMove, deltaX));
      const moveY = Math.max(-maxMove, Math.min(maxMove, deltaY));

      applyCombinedParallax(moveX, moveY);
    };

    const applyScrollParallax = () => {
      const scrollY = window.scrollY;
      const sectionBottom = sectionTop + sectionHeight;
      const viewportTop = scrollY;
      const viewportBottom = scrollY + window.innerHeight;
      const tolerance = window.innerHeight * 0.25;

      const isVisible = !(
        sectionBottom < viewportTop - tolerance ||
        sectionTop > viewportBottom + tolerance
      );

      if (!isVisible) {
        applyCombinedParallax(0, 0);
        return;
      }

      const sectionScrollStart = sectionTop - window.innerHeight - tolerance;
      const sectionScrollEnd = sectionBottom + tolerance;

      const progress = Math.max(
        0,
        Math.min(
          1,
          (scrollY - sectionScrollStart) /
            (sectionScrollEnd - sectionScrollStart)
        )
      );

      const angle = progress * Math.PI * 2;

      const scrollX = Math.cos(angle) * maxMove;
      const scrollYMove = Math.sin(angle) * maxMove;

      applyCombinedParallax(scrollX, scrollYMove);
    };

    parent.addEventListener('mousemove', (e) => {
      if (!tickingMouse) {
        window.requestAnimationFrame(() => {
          applyMouseParallax(e);
          tickingMouse = false;
        });
        tickingMouse = true;
      }
    });

    parent.addEventListener('mouseleave', resetParallax);

    window.addEventListener('scroll', () => {
      if (!tickingScroll) {
        window.requestAnimationFrame(() => {
          applyScrollParallax();
          tickingScroll = false;
        });
        tickingScroll = true;
      }
    });

    container.classList.add('parallax-active');
    applyScrollParallax();
  },
};

// Home
const homeApp = {
  init() {
    this.initObjetivosAnimation();
    this.initGenometroAnimation();
  },

  initObjetivosAnimation() {
    const section = document.getElementById('objetivos-section');
    if (!section) return;

    const cards = section.querySelectorAll('.cards.objetivo');
    if (!cards.length) return;

    const animateCards = () => {
      cards.forEach((card, index) => {
        setTimeout(() => card.classList.add('animate-in'), index * 500);
      });
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCards();
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(section);
  },

  initGenometroAnimation() {
    const section = document.getElementById('genometro-section');
    if (!section) return;

    const cards = section.querySelectorAll('.cards.genometro');
    if (!cards.length) return;

    const animateCards = () => {
      cards.forEach((card, index) => {
        setTimeout(() => card.classList.add('animate-in'), index * 300);
      });
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCards();
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(section);
  },
};
const timelineApp = {
  init() {
    const timelineSection = document.querySelector("#time-line-section");
    const timelineMarks = document.querySelectorAll(".timeline-mark");
    const progressMarker = document.querySelector(".progress-marker");
    const items = document.querySelectorAll(".timeline-items .item");
    const yearHeaders = document.querySelectorAll(".timeline-year-header");
    const controller = document.querySelector(".timeline-controller");
    const skipButton = document.querySelector("#skip-timeline");

    if (!timelineSection || !timelineMarks.length || !controller) return;

    function positionMarks() {
      let pos = 0;
      const spacing = 18;

      timelineMarks.forEach(mark => {
        mark.style.position = "absolute";
        mark.style.top = `${pos}px`;
        pos += spacing;
      });

      controller.style.height = `${pos}px`;
      controller.style.right = "8px";
    }

    function updateControllerVisibility() {
      const rect = timelineSection.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const atOrPastStart = rect.top <= 0;
      const beforeEnd = rect.bottom >= viewportHeight;

      if (atOrPastStart && beforeEnd) {
        controller.style.opacity = "1";
        controller.style.visibility = "visible";

        if (skipButton) skipButton.classList.add("visible");

      } else {
        controller.style.opacity = "0";
        controller.style.visibility = "hidden";

        if (skipButton) skipButton.classList.remove("visible");
      }
    }

    function scrollToElement(el) {
      if (!el) return;
      const offset = window.innerHeight * 0.25;
      const y = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    timelineMarks.forEach(mark => {
      mark.addEventListener("click", () => {
        const year = mark.dataset.year;
        const month = mark.dataset.month;

        if (!month) {
          scrollToElement(document.getElementById(`year-${year}`));
          return;
        }

        const target = [...items].find(item => {
          const m = item.querySelector(".month")?.textContent.trim();
          const y = item.closest(".timeline-items")
            ?.previousElementSibling?.id.replace("year-", "");
          return m === month && y === year;
        });

        scrollToElement(target);
      });
    });

    function updateActiveMarks() {
      const mid = window.innerHeight / 2;
      timelineMarks.forEach(m => m.classList.remove("active"));

      // Meses
      items.forEach(item => {
        const rect = item.getBoundingClientRect();
        if (rect.top < mid && rect.bottom > mid) {
          const month = item.querySelector(".month")?.textContent.trim();
          const year = item.closest(".timeline-items")
            ?.previousElementSibling?.id.replace("year-", "");
          const mark = document.querySelector(
            `.timeline-mark[data-year="${year}"][data-month="${month}"]`
          );
          if (mark) mark.classList.add("active");
        }
      });

      // Anos
      yearHeaders.forEach(head => {
        const rect = head.getBoundingClientRect();
        if (rect.top < mid && rect.bottom > mid) {
          const year = head.id.replace("year-", "");
          const mark = document.querySelector(
            `.timeline-mark.year-mark[data-year="${year}"]`
          );
          if (mark) mark.classList.add("active");
        }
      });

      updateProgressMarker();
    }

    function updateProgressMarker() {
      const active = [...timelineMarks].find(m => m.classList.contains("active"));
      if (!active) return;

      const markCenter = active.offsetTop + active.offsetHeight / 2;
      const markerCenter = progressMarker.offsetHeight / 2;
      const visualOffset = 10;

      progressMarker.style.top = `${markCenter - markerCenter + visualOffset}px`;
    }

    positionMarks();
    updateActiveMarks();
    updateControllerVisibility();

    window.addEventListener("scroll", () => {
      updateActiveMarks();
      updateControllerVisibility();
    });

    window.addEventListener("resize", () => {
      positionMarks();
      updateActiveMarks();
      updateControllerVisibility();
    });

    if (skipButton) {
      skipButton.addEventListener("click", () => {
        const rect = timelineSection.getBoundingClientRect();
        const targetY = window.scrollY + rect.bottom + 20;

        window.scrollTo({
          top: targetY,
          behavior: "smooth"
        });
      });
    }

    ScrollOut({
      targets: '.timeline-items .item',
      once: true,
      threshold: 0.95
    });

  }
};
const videoApp = {
  init() {
    this.bindEvents();
  },

  bindEvents() {
    const playBtn = document.querySelector(".video-play-btn");

    if (playBtn) {
      playBtn.addEventListener("click", () => this.playVideo());
    }
  },

  playVideo() {
    const video = document.getElementById("video-home");
    const overlay = document.querySelector(".video-overlay");

    if (!video) return;

    // Ajustes importantes para iOS
    video.muted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("controls", "");

    if (overlay) {
      overlay.style.opacity = "0";
      overlay.style.pointerEvents = "none";
      setTimeout(() => {
        overlay.style.display = "none";
      }, 300);
    }

    video.play().catch(() => {
      // fallback iOS
      video.muted = true;
      video.play();
    });
  },
};

// Como participar
const comoParticiparApp = {
  init: () => {
    setTimeout(() => {
      const categories = document.querySelectorAll('.filter-category');
      categories.length &&
        categories.forEach(el =>
          el.addEventListener('click', () =>
            window.openFilterModal?.(el.dataset.category)
          )
        );
    }, 100);

    const modal = document.getElementById('filter-modal');
    const title = document.getElementById('modal-title');
    const groups = document.querySelectorAll('[id^="filters-"]');
    const applyBtn = document.getElementById('apply-filters');

    const titles = {
      especie: window.GBB_I18N?.filterBySpecies ?? 'Filtrar por Espécie',
      localidade: window.GBB_I18N?.filterByLocation ?? 'Filtrar por Localidade',
      escopo: window.GBB_I18N?.filterByScope ?? 'Filtrar por Escopo',
    };

    // abrir modal
    window.openFilterModal = category => {
      modal.classList.replace('hidden', 'flex');
      document.body.style.overflow = 'hidden';
      groups.forEach(g => g.classList.add('hidden'));
      document.getElementById(`filters-${category}`)?.classList.remove('hidden');
      title.textContent = titles[category] ?? (window.GBB_I18N?.selectToFilter ?? 'Selecione para filtrar');
    };

    // fechar modal
    const closeModal = () => {
      modal.classList.replace('flex', 'hidden');
      document.body.style.overflow = '';
    };

    // clicar fora ou no botão "X"
    modal.addEventListener('click', e => {
      if (e.target === modal || e.target.closest('#close-modal')) closeModal();
    });

    // fechar com tecla ESC
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeModal();
    });

    // fechar modal ao clicar em filtrar
    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        closeModal();
      });
    }
  },
};

// Carregamento publicações repositorio externo
const publicacoesApp = {
    // Renderiza um card real
    renderCard: (item) => {
        const thumb = item.thumbnail
            ? `<img src="${item.thumbnail}" alt="${item.name}" loading="lazy">`
            : `<figure class="placeholder"></figure>`;

        return `
            <a href="${item.pdf_url}" class="cards publicacao" target="_blank" rel="noopener">
                <div class="image">
                    <figure>${thumb}</figure>
                </div>
                <div class="content">
                    <div class="description">${item.name}</div>

                    <button class="button-gbb">
                        <span>Acesse</span>
                        <div class="icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor"/>
                            </svg>
                        </div>
                    </button>
                </div>
            </a>
        `;
    },

    // Remove loaders e insere publicações reais
    render: (items, texts) => {
        const container = document.getElementById('ultimas-publicacoes-container');
        if (!container) return;

        // Remove todos os loaders inteiros
        container.querySelectorAll('.is-loading').forEach(el => el.remove());

        if (!items.length) {
            container.innerHTML = `<p class="text-sm text-gray-500">${texts.none}</p>`;
            return;
        }

        // Renderiza 3 itens
        items.slice(0, 3).forEach(item => {
            container.insertAdjacentHTML('beforeend', publicacoesApp.renderCard(item));
        });
    },

    // Inicia o módulo
    init: () => {
        const secao = document.getElementById('ultimas-publicacoes-section');
        if (!secao) return;

        const container = document.getElementById('ultimas-publicacoes-container');
        if (!container) return;

        const proxyUrl = secao.dataset.proxyUrl;
        const texts = {
            none: secao.dataset.textNone || 'Nenhuma publicação encontrada.',
            error: secao.dataset.textError || 'Erro ao carregar publicações.',
        };

        if (!proxyUrl) return;

        fetch(proxyUrl)
            .then(res => res.json())
            .then(data => {
                publicacoesApp.render(Array.isArray(data) ? data : [], texts);
            })
            .catch(err => {
                console.error('Erro ao carregar publicações:', err);
                container.innerHTML = `<p class="text-sm text-gray-500">${texts.error}</p>`;
            });
    }
};

// Start
function start() {
  var current_page = mainContent.dataset.page;
  wh = window.innerHeight;
  ww = window.innerWidth;

  generalApp.init();
  parallaxApp.init();
  publicacoesApp.init();
  updateSelectedTags();
  clearSearch();

  switch (current_page) {
    case 'home':
      homeApp.init();
      timelineApp.init();
      videoApp.init();
    break;
    case 'como-participar':
      comoParticiparApp.init();
    default:
    break;
  }
  
  scrollWatch();
}
document.addEventListener("DOMContentLoaded", start);
window.addEventListener("scroll", scrollWatch);



